import { setDateFormat } from '../utilities'
import { getPdfSVG, getAudioSvg } from './get-svgs'

export function getDataTranslated (customArray, valueToSearch) {
  let shopLocale = 'en'
  if (window.theme.settings.shopLocale) shopLocale = window.theme.settings.shopLocale

  if (!customArray.language_translations) return

  let dataTranslated = customArray.language_translations

  if (!dataTranslated[`${shopLocale}_language`]) return

  dataTranslated = dataTranslated[`${shopLocale}_language`]

  return dataTranslated[valueToSearch]
}

export function bookDataOverrides (item) {
  if (!item.custom) return
  const customArray = item.custom

  // Replace description
  if (getDataTranslated(customArray, 'description')) item.description = getDataTranslated(customArray, 'description')

  // Replace author bios
  if (getDataTranslated(customArray, 'authorbio')) {
    const customBios = getDataTranslated(customArray, 'authorbio')
    const contributorBios = []
    contributorBios.push({ bio: customBios })
    item.templateVars.contributorBios = contributorBios
  }

  // Replace Reviews
  if (getDataTranslated(customArray, 'reviews')) {
    const customReviews = getDataTranslated(customArray, 'reviews')
    const reviewsArray = []
    reviewsArray.push({
      review: {
        description: customReviews
      }
    })
    item.reviews = reviewsArray
  }

  // Replace Videos Data
  if (getDataTranslated(customArray, 'video')) {
    const customVideo = getDataTranslated(customArray, 'video')
    const videoArray = []
    videoArray.push({
      embed: customVideo
    })
    item.templateVars.videos = videoArray
  }
}

export function getShortDescription (item, showBookDetails) {
  let descriptionData = ''
  let readMoreAlreadyAdded = false
  const readMoreButton = `<a href="#detailsTab" title="Read More" class="product__description-more js-product__description-more"> ${item.languages.read_more}</a>`

  if (!item.description && !item.summary) {
    return descriptionData
  }

  if (showBookDetails.show_summary && item.summary) {
    let summaryData = getDataTranslated(item.custom, 'summary') || item.summary

    const stripHTMLsummary = summaryData.replace(/<[^>]*>?/gm, '')
    if (stripHTMLsummary.length > 600) {
      summaryData = `${summaryData.substring(0, 600)}... ${readMoreButton}`
      readMoreAlreadyAdded = true
    }

    descriptionData += `<span class="product__summary">${summaryData}</span>`
  }

  if (showBookDetails.show_description) {
    // get custom description first
    let description = getDataTranslated(item.custom, 'description')

    // set to default if translated description empty
    if (!description) {
      description = item.description
    }

    const stripHTMLdescription = description.replace(/<[^>]*>?/gm, '')

    if (stripHTMLdescription.length > 600) {
      descriptionData += `${description.substring(0, 600)}... ${readMoreButton}`
      readMoreAlreadyAdded = true
    } else {
      descriptionData += description
    }
  }

  if (descriptionData && !readMoreAlreadyAdded && showBookDetails.show_read_more) {
    descriptionData += readMoreButton
  }

  return descriptionData
}

export function getBisacs (item) {
  if (!item.categories) {
    return ''
  }

  return item.categories.filter((cat) => {
    return cat.category.type === 'bisac'
  }).map((cat) => {
    if (cat.category.name) return cat.category.name
  }).join('<br>')
}

export function getAges (item) {
  if (!item.levels) return

  const ageLevels = item.levels.filter((age) => {
    return age.level.type === 'Age' && (age.level.name === 'from' || age.level.name === 'to')
  })

  if (!ageLevels || !ageLevels.length) return

  if (!ageLevels.some(age => age.level.name === 'from')) {
    const ageTo = ageLevels.find(age => age.level.name === 'to')
    return `0-${ageTo.level.code}`
  }

  if (!ageLevels.some(age => age.level.name === 'to')) {
    const ageFrom = ageLevels.find(age => age.level.name === 'from')
    return `${ageFrom.level.code}+`
  }

  return ageLevels.map((age) => {
    return age.level.code
  }).sort((a, b) => a - b).join('-')
}

export function bookDimensionsString (trim) {
  let dimensions = ''
  if (!trim.width || !trim.height) {
    return dimensions
  }

  let width = trim.width
  let height = trim.height

  if (!parseFloat(trim.width) || !parseFloat(trim.height)) {
    return dimensions
  }

  width = parseFloat(trim.width).toString()
  height = parseFloat(trim.height).toString()
  const unit = trim.unit ? ` ${trim.unit}` : ''
  dimensions = `<span>${width}</span> x <span>${height}</span>${unit}`

  return dimensions
}

export function bookDimensions (item) {
  const customArray = item.custom
  // Book Dimensions
  const dimensions = []
  if (bookDimensionsString(item.trim)) {
    dimensions.push(bookDimensionsString(item.trim))
  }

  if (!customArray.metric_trim) {
    return dimensions.join()
  }

  dimensions.push(bookDimensionsString(customArray.metric_trim))

  return dimensions.join(' / ')
}

export function publicationDate (item) {
  // Set Publication Date
  let publicationDate = ''
  let formattedPubDate = ''

  if (
    window.theme.settings.bookDetailsSettings &&
    window.theme.settings.bookDetailsSettings.publication_date_value &&
    window.theme.settings.bookDetailsSettings.publication_date_value === 'sale_date' &&
    item.sale_date &&
    item.sale_date.date
  ) {
    publicationDate = item.sale_date.date
  } else if (
    (
      !window.theme.settings.bookDetailsSettings ||
      window.theme.settings.bookDetailsSettings.publication_date_value === 'publication_date' ||
      !publicationDate
    ) &&
    item.date &&
    item.date.date
  ) {
    publicationDate = item.date.date
  }

  if (!publicationDate) {
    return ''
  }

  publicationDate = new Date(publicationDate.replace(/ /g, 'T'))
  if (publicationDate && publicationDate instanceof Date && !isNaN(publicationDate)) {
    formattedPubDate = setDateFormat(publicationDate)
  }

  return formattedPubDate
}

export function getReviews (item) {
  if (!item.reviews || !item.reviews.length) {
    return ''
  }

  return item.reviews.filter((review) => {
    return review.review.description !== null || review.review.description !== ''
  })
}

export function getContributorBios (item) {
  const contributorBios = []
  if (item.assets && item.assets.length) {
    item.assets.forEach((asset) => {
      if (!asset.asset) {
        return
      }
      if (asset.asset.sub_type === 'contributor-bio' && asset.asset.type === 'rich-text') {
        if (asset.asset.description) {
          contributorBios.push({ bio: asset.asset.description })
        }
      }
    })
  }

  if (!item.contributors || !item.contributors.length || contributorBios.length) {
    return contributorBios
  }

  item.contributors.forEach((contributor) => {
    if (!contributor.contributor) {
      return
    }

    const contributorData = contributor.contributor

    if (!contributorData.image && !contributorData.bio) {
      return
    }

    contributorBios.push({
      image: contributorData.image,
      bio: contributorData.bio
    })
  })

  return contributorBios
}

export function getVideos (assets) {
  const videos = []
  /* Loop through assets to find videos */
  if (!assets || !assets.length) {
    return videos
  }
  assets.forEach((asset) => {
    let videoEmbed = ''
    if (!asset.asset) {
      return
    }

    const assetObject = asset.asset

    if (assetObject.type !== 'html-embeded' && assetObject.type !== 'link-url') {
      return
    }
    if (assetObject.sub_type !== 'video-video' && assetObject.sub_type !== 'youtube-video') {
      return
    }
    if (assetObject.embed && assetObject.embed.includes('.mp3')) {
      return
    }

    if (assetObject.type === 'link-url' && !assetObject.embed) {
      if (!assetObject.path) {
        return
      }

      let videoPath = assetObject.path
      let videoID = ''

      if (videoPath.includes('https://www.youtube.com/watch?v=')) {
        videoID = videoPath.split('v=').pop()
        if (!videoID) return
        videoPath = `https://www.youtube.com/embed/${videoID}`
      }
      if (videoPath.includes('https://youtu.be/')) {
        videoID = videoPath.split('https://youtu.be/').pop()
        if (!videoID) return
        videoPath = `https://www.youtube.com/embed/${videoID}`
      }

      videoEmbed = `<iframe width='560' height='315' src="${videoPath}" frameborder="0" allowfullscreen=""></iframe>`
    } else {
      videoEmbed = assetObject.embed
    }

    videos.push({
      name: assetObject.name,
      embed: videoEmbed
    })
  })

  return videos
}

export function getTOC (assets) {
  /* Loop through assets to find videos */
  if (!assets || !assets.length) {
    return ''
  }

  return assets.filter(asset => {
    if (!asset.asset) {
      return
    }
    const assetObject = asset.asset
    if (!assetObject.type || !assetObject.sub_type || !assetObject.description) {
      return
    }
    return assetObject.type === 'rich-text' && assetObject.sub_type === 'content'
  }).map(toc => {
    if (!toc.asset.description) {
      return
    }
    return toc.asset.description
  })
}

export function getPDFs (item) {
  if (
    !window.theme.settings.bookDetailsSettings ||
    !window.theme.settings.bookDetailsSettings.pdf_resources_label
  ) return

  const languagesLabels = item.languages

  return item.assets.filter(asset => {
    if (!asset.asset) {
      return
    }
    const assetObject = asset.asset
    if (!assetObject.type || !assetObject.sub_type || !assetObject.path) {
      return
    }
    return assetObject.type === 'pdf'
  }).map((asset) => {
    const labelValue = window.theme.settings.bookDetailsSettings.pdf_resources_label
    let pdfName
    if (labelValue === 'sub_type') {
      const subType = asset.asset.sub_type
      pdfName = subType.replace('-', ' ')

      if (languagesLabels[`${subType}-pdf`]) {
        pdfName = languagesLabels[`${subType}-pdf`]
      }
    } else {
      pdfName = asset.asset.name
    }

    const pdfSvg = getPdfSVG()
    return `<a href='${asset.asset.path}' target="_blank" title="${pdfName}" class="sp__pdf"><span>${pdfSvg}</span>${pdfName}</a>`
  })
}

export function getResources (item) {
  /* Loop through assets to find videos */
  if (!item.assets || !item.assets.length) {
    return ''
  }

  const assets = item.assets
  const pdfs = getPDFs(item)
  const resourcesArray = []

  const resourceLinks = assets.filter(asset => {
    if (!asset.asset) {
      return
    }
    const assetObject = asset.asset
    if (!assetObject.type || !assetObject.sub_type || !assetObject.path) {
      return
    }
    return assetObject.type === 'link-url' && assetObject.sub_type === 'resource-link'
  }).map(asset => {
    if (!asset.asset.path && !asset.asset.name) {
      return
    }
    return `<a href='${asset.asset.path}' target="_blank" title="${asset.asset.name}">${asset.asset.name}</a>`
  })

  return resourcesArray.concat(pdfs, resourceLinks)
}

export function getAudioSample (item) {
  let audioSample = ''
  /* Loop through assets to find videos */
  if (!item.assets || !item.assets.length) {
    return audioSample
  }

  const audioAsset = item.assets.find(asset => {
    if (!asset.asset) {
      return
    }
    const assetObject = asset.asset
    if (!assetObject.type || !assetObject.sub_type || !assetObject.path) {
      return
    }
    return assetObject.type === 'mp3' && assetObject.sub_type === 'audio-excerpts'
  })

  if (!audioAsset || !audioAsset.asset || !audioAsset.asset.path) {
    return audioSample
  }

  const audioSVG = getAudioSvg()
  audioSample = `<div class="audio-sample">
                    <figure style="margin: 0px;">
                      <figcaption>${audioSVG} Listen to an Audio Sample</figcaption>
                      <audio controls="" preload="metadata" title="Listen ${item.title} sample">
                        <source src="${audioAsset.asset.path}"
                                type="audio/mp3">
                        Your browser does not support the audio element.
                      </audio>
                    </figure>
                  </div>`

  return audioSample
}

export function getBookInteriorImages (item) {
  const otherCoversContainer = document.getElementById(
    'product-details-other-covers'
  )

  if (!item.assets || !item.assets.length) {
    return
  }

  let arrayFiltered = item.assets.filter(asset => {
    if (!asset.asset) {
      return
    }
    const assetObject = asset.asset
    if (!assetObject.type || !assetObject.sub_type || !assetObject.path) {
      return
    }
    return assetObject.type === 'image' && assetObject.width === '145' && assetObject.sub_type === 'book-interior'
  })

  if (window.theme.settings.bookDetailsSettings && window.theme.settings.bookDetailsSettings.interior_images_limit) {
    arrayFiltered = arrayFiltered.slice(0, window.theme.settings.bookDetailsSettings.interior_images_limit)
  }

  if (!arrayFiltered.length || !otherCoversContainer) {
    return ''
  }

  arrayFiltered.forEach(cover => {
    otherCoversContainer.insertAdjacentHTML(
      'beforeend',
      `<img src="${cover.asset.path}" alt="${item.title}" class="js-modal-open-product-image-modal">`
    )
  })
}

export function getAccessibilityInfo (item) {
  const hasBasicAccessibilityInfo = item.custom.accesibility_info && typeof item.custom.accesibility_info === 'object'
  const hasExtendedAccessibilityInfo = item.custom.extended_accessibility_info && typeof item.custom.extended_accessibility_info === 'object'

  if (!hasBasicAccessibilityInfo && !hasExtendedAccessibilityInfo) {
    return window.theme.settings.accessibility_fallback || ''
  }

  // Only show extended accessibility info if it exists
  if (hasExtendedAccessibilityInfo) {
    return `
    <div class="extended-accessibility">
      ${Object.entries(item.custom.extended_accessibility_info).map(([category, categoryData]) => {
        if (categoryData && categoryData.texts && typeof categoryData.texts === 'object') {
          const textItems = Object.entries(categoryData.texts).map(([code, text]) => {
            return `<li class="accessibility-item" data-code="${code}">${text}</li>`
          }).join('')
          return `
            <span class="extended-accessibility__title">
              <strong>${category}</strong>
            </span>
            <ul class="accessibility-list">
              ${textItems}
            </ul>
          `
        }
        return ''
      }).join('')}
    </div>`
  }

  return `
  <ul class="accessibility-list">
    ${Object.entries(item.custom.accesibility_info).map(([key, value]) => {
      return `<li class="accessibility-item" data-code="${key}">${value}</li>`
    }).join('')}
  </ul>`
}
